module.exports = __webpack_public_path__ + "static/Planet.cccc80c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Galaxy/images/Planet.png
// module id = 337
// module chunks = 168707334958949